export default "__VITE_ASSET__c8751da7__"